<mat-card>
  <div #exportContent>
    <div class="header">
      <mat-card-title>System Resiliency Statistics</mat-card-title>
      <button class="header-btn" data-html2canvas-ignore mat-icon-button (click)="export()">
        <vulcan-icon size="24px" icon="download"></vulcan-icon>
      </button>
    </div>
    <mat-card-content>
      @if (resource.isLoading()) {
        <span>loading</span>
      } @else if (resource.error()) {
        <span>{{ resource.error() }}</span>
      } @else {
        <!-- This should be removed once we start pulling in SRC data and not just reading from static files -->
        <div [innerHTML]="resource.value()! | sanitize"></div>
      }

    </mat-card-content>
  </div>
</mat-card>
